import { render, staticRenderFns } from "./BookingSection.vue?vue&type=template&id=4f48a707&"
import script from "./BookingSection.vue?vue&type=script&lang=js&"
export * from "./BookingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f48a707')) {
      api.createRecord('4f48a707', component.options)
    } else {
      api.reload('4f48a707', component.options)
    }
    module.hot.accept("./BookingSection.vue?vue&type=template&id=4f48a707&", function () {
      api.rerender('4f48a707', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/BookingSection.vue"
export default component.exports